import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  ExportDataTable,
  ExportableCollection,
  PdfFromDataTableService,
  PdfOrientationEnum,
  PdfSettings, XlsxService
} from 'taxtank-core';
import { plainToClass } from 'class-transformer';
import { ExportComponent } from '@shared/component/export/export.component';

declare type ViewType = 'button' | 'icon' | 'text';

/**
 * @TODO remove?
 */
@Component({
  selector: 'app-data-table-export',
  templateUrl: './data-table-export.component.html',
  styleUrls: ['./data-table-export.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DataTableExportComponent extends ExportComponent {
  @Input() tables: ExportDataTable[];
  @Input() type: number;
  @Input() label?: string;
  @Input() collection?: ExportableCollection<any>;
  @Input() viewType: ViewType = 'button';
  @Input() orientation: PdfOrientationEnum = PdfOrientationEnum.PORTRAIT;

  private pdfFromDataTableService = inject(PdfFromDataTableService);
  private xlsxService = inject(XlsxService);

  export(): void {
    if (this.tables) {
      this.exportToPdf();
    } else {
      this.exportToXLSX();
    }
  }

  exportToPdf(): void {
    this.pdfFromDataTableService.export(
      this.tables,
      plainToClass(PdfSettings, {
        title: this.title,
        filename: this.filename,
        orientation: this.orientation,
        subtitle: this.subtitle,
        description: this.description
      })
    );
  }

  exportToXLSX(): void {
    this.xlsxService.exportArrayToExcel(this.collection, this.filename);
  }
}
